import React from "react";
import { Table, Dropdown, Button, Tag } from "antd";
import { MoreOutlined } from "@ant-design/icons";

const ReusableTable = ({ columns, dataSource, loading, actionItems, useFixedHeight=false, paginationConfig, onChange }) => {
  // Actions Column
  const actionColumn =
  typeof actionItems === "function"
    ? {
        title: "Actions",
        key: "actions",
        fixed: "right",
        width: 80,
        render: (record) => {
          const actions = actionItems(record);
          return (
            <div className="tableDropdown">
              <Dropdown
                menu={{
                  items: actions.map((item) => ({
                    key: item.key,
                    label: item.label,
                    onClick: () => item.onClick(record),
                  })),
                }}
                trigger={["click"]}
              >
                <Button shape="circle" icon={<MoreOutlined />} />
              </Dropdown>
            </div>
          );
        },
      }
    : null;

  return (
    <div className="commonTable">
      <Table
        columns={actionColumn ? [...columns, actionColumn] : columns}
        dataSource={dataSource?.map((item, index) => ({ 
          ...item, 
          key: item.id || index // Use `id` if available; fallback to `index`
        }))}
        // dataSource={dataSource}
        loading={loading}
        pagination={paginationConfig}
        onChange={onChange} 
        scroll={useFixedHeight ?  { x: "max-content" } : { x: "max-content", y: 500 } }
        sticky
      />
    </div>
  );
};

export default ReusableTable;
